import { FormSpy } from 'react-final-form';

import type { FormRenderProps, PetitionUpdateFormValues } from '../../types';
import { DescriptionTextArea } from '../DescriptionTextArea/index_new';
import { ErrorMessage } from '../ErrorMessage';
import { ImageUploadContainer } from '../ImageUploadContainer/index_new';
import { PreviewEmailButton } from '../PreviewEmailButton/index_new';
import { SubmitButton } from '../SubmitButton/index_new';
import { TitleInput } from '../TitleInput/index_new';

export function FormRender({
	handleSubmit,
	initialValues,
	hasValidationErrors,
	onPreview,
	isCurrentlyLoading,
	uploader,
	error,
}: FormRenderProps) {
	return (
		<form onSubmit={handleSubmit} autoComplete="off" className="mt-6" data-qa="petition-update-form">
			<div className="flex flex-col flex-wrap justify-end gap-8 md:flex-row">
				<TitleInput initialValue={initialValues.title} />
				<ImageUploadContainer uploader={uploader} />
				<DescriptionTextArea initialValue={initialValues.description} />
				{error && <ErrorMessage errorType={error} />}
				<div className="flex w-full flex-col flex-wrap justify-end gap-4 md:flex-row">
					<FormSpy<PetitionUpdateFormValues> subscription={{ values: true }}>
						{(props) => (
							<PreviewEmailButton
								data-qa="petition-update-preview-email-button"
								onClick={async () => onPreview(props.values)}
								disabled={hasValidationErrors || isCurrentlyLoading}
							/>
						)}
					</FormSpy>
					<SubmitButton hasValidationErrors={hasValidationErrors} loading={isCurrentlyLoading} />
				</div>
			</div>
		</form>
	);
}
